module.exports = {"last_5min":"Last 5 minuntes","last_hour":"Last 1 hour","last_three_hour":"Last 3 hours","last_six_hour":"Last 6 hours","last_day":"Last 1 day","last_seven_day":"Last seven days","last_month":"Last month","this_month":"This month","custom":"custom","search":"search","selectServerNameText":"ServerName","selectAppProfileNameText":"App Profile","selectOriginText":"Origin","selectServiceGroupText":"Site","selectAppProfileText":"Service Name","selectedGroupNameText":"Group","selectedSlbNameText":"Slb","selectedEdgeNameText":"Edge"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/home.json
// module id = Hj9L
// module chunks = 3